// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"febf0c5f","703":"679fe078","787":"fda426b6"}[chunkId] + ".chunk.js";
};